import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const ImageCarousel = ({ items }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Auto-advance the carousel every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      handleNext();
    }, 5000);

    return () => clearInterval(timer);
  }, [currentIndex]);

  const handlePrevious = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentIndex((prev) => (prev === 0 ? items.length - 1 : prev - 1));
      setTimeout(() => setIsTransitioning(false), 500);
    }
  };

  const handleNext = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentIndex((prev) => (prev === items.length - 1 ? 0 : prev + 1));
      setTimeout(() => setIsTransitioning(false), 500);
    }
  };

  const goToSlide = (index) => {
    if (!isTransitioning && index !== currentIndex) {
      setIsTransitioning(true);
      setCurrentIndex(index);
      setTimeout(() => setIsTransitioning(false), 500);
    }
  };

  return (
    <>
      <div className="relative w-full mx-auto overflow-hidden rounded-lg shadow-1">
        {/* Main carousel container */}
        <div className="text-main mt-5 text-center px-5 text-2xl font-bold ml-3">
          Our clients pics 📸{" "}
        </div>
        <div className="relative h-96">
          {/* Images container with transition */}
          <div
            className="absolute w-full h-full flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {items.map((url, index) => (
              <div
                key={index}
                className="min-w-full h-full flex items-center justify-center p-8"
              >
                <img
                  src={url}
                  alt={`Slide ${index + 1}`}
                  className="max-w-full max-h-full object-contain "
                />
              </div>
            ))}
          </div>

          {/* Navigation buttons */}
          <button
            onClick={handlePrevious}
            className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-lg transition-all"
            disabled={isTransitioning}
          >
            <ChevronLeft className="w-6 h-6 text-gray-800" />
          </button>
          <button
            onClick={handleNext}
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-lg transition-all"
            disabled={isTransitioning}
          >
            <ChevronRight className="w-6 h-6 text-gray-800" />
          </button>

          {/* Dots navigation */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
            {items.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-2 h-2 rounded-full transition-all ${
                  index === currentIndex
                    ? "bg-blue-500 w-4"
                    : "bg-gray-400 hover:bg-gray-600"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default function ModernCarousel() {
  const images = [
    "https://d8czg093l6apo.cloudfront.net/clientPics/%D8%A7%D9%88%D9%84-%D8%B5%D9%88%D8%B1%D8%A9.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/1.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/2.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/3.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/4.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/5.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/6.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/7.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/8.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/9.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/10.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/11.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/12.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/13.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/14.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/15.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/16.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/17.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/18.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/19.png",
  "https://d8czg093l6apo.cloudfront.net/clientPics/20.png",
];


  return (
    <div className="p-4">
      <ImageCarousel items={images} />
    </div>
  );
}
